import { render, staticRenderFns } from "./kryptButton.vue?vue&type=template&id=9d67a006&scoped=true&"
import script from "./kryptButton.vue?vue&type=script&lang=js&"
export * from "./kryptButton.vue?vue&type=script&lang=js&"
import style0 from "./kryptButton.vue?vue&type=style&index=0&id=9d67a006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d67a006",
  null
  
)

export default component.exports